export default "__VITE_ASSET__DjLGwyAi__"